/*
 * @Author: linbin@leedarson.com
 * @Date: 2022-11-30 09:30:46
 * Copyright © Leedarson. All rights reserved.
 */

import { isInApp, isIos } from '@root/shared';
import {
  getCurrentAuth,
  getCurrentHouseId,
  getCurrentToken,
} from '@root/shared/currentAuth';
import getDateTime from '@root/shared/getDateTime';

const builder = (original: object): any => {
  const { href } = window.location;
  const { id: userId, username } = getCurrentAuth();
  const houseId = getCurrentHouseId();
  const accessToken = getCurrentToken();

  return {
    time: Date.now(),
    create: getDateTime(),
    service: 'WebPayment',
    userId,
    username,
    houseId,
    accessToken,
    // webVersion: process.env.WEB_VERSION,
    // webBuilderNumber: process.env.WEB_BUILDER_NUMBER,
    os: `${isInApp ? 'App' : 'Web'}-${isIos ? 'iOS' : 'Android'}`, // 系统  window/Mac OS/...
    // osVersion: '', // osInfo.version, // 系统版本10, 11,
    // browserVersion: browserInfo.version, // 浏览器版本
    href,
    // pathname,
    browser: navigator.vendor,
    ...original,
  };
};

export default builder;
